<mat-dialog-content>
  <mat-card-title>{{ 'ecase.explorer.documentList.replace.title' | translate }}</mat-card-title>
  <div *ngIf="uploadedFile">
    <span>{{ uploadedFile.name }}</span>
    <button (click)="removeFile()"
            mat-icon-button
            color="accent"
            [disabled]="submitting"
            [attr.aria-label]="'ecase.explorer.documentList.replace.removeFileAriaLabel' | translate">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div *ngIf="!uploadedFile">
    <input #uploader
           id="fileToBeReplaced"
           type="file"
           hidden
           (change)="uploadFile($event)"
           [attr.aria-label]="'ecase.explorer.documentList.replace.fileToUpload' | translate">
    <button mat-raised-button
            [disabled]="submitting"
            (click)="uploader.click()"
            style="margin-top: 5px; margin-bottom: 10px">
      <mat-icon>cloud_upload</mat-icon>
      <span style="padding-left: 5px">{{ 'ecase.explorer.documentList.replace.fileToUpload' | translate }}</span>
    </button>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="eCase-dialog-action-button-align">
    <button class="eCase-dialog-positive-action-button"
            [disabled]="!uploadedFile || submitting"
            [attr.aria-busy]="submitting"
            mat-raised-button
            (click)="onConfirm()">
      <span class="replace-confirm-content">
        <mat-spinner *ngIf="submitting"
                     [diameter]="20"
                     [attr.aria-label]="('ecase.explorer.documentList.replace.title' | translate) + '…'">
        </mat-spinner>
        <span>{{ 'ecase.explorer.documentList.replace.title' | translate }}</span>
      </span>
    </button>
    <button class="eCase-dialog-negative-action-button"
            [disabled]="submitting"
            (click)="onClose()"
            mat-raised-button>
      {{ 'ecase.common.cancel' | translate }}
    </button>
  </div>
</mat-dialog-actions>
